import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.UsersPage.OffboardUserPopupContent.ApprovalWorkflows', {
    autoApprovalStep: 'Auto-Approval step',
    noData: 'There are no associated workflows.',
    nameColumn: 'Workflow name',
    stepColumn: 'Step',
    roleColumn: 'Role',
    replacementColumn: 'Replacement',
});
